import React, {Component} from "react";
import {connect} from "react-redux";
import {Field, reduxForm} from "redux-form/immutable";
import {submit} from "redux-form";
import ActionButton from "../../ActionButton";
import FormFieldsTable from "../../forms/FormFieldsTable";
import DropDownInputField from "../../forms/DropDownInputField";
import TextInputField from "../../forms/TextInputField";
import {fromJS, Map} from "immutable";
import {validateIncludes, validatePresence} from "../../../lib/Validators";
import {cancelRecordWaterTestResult, recordWaterTestResult} from "../../../actions/InventoryApiActions";
import {getSubmitInfoForCommand} from "../../../reducers/inventoryReducer";
import {isSubmitting, submitLabel} from "../../../lib/CommandStatus";

const resultOptions = fromJS([
  { id: "accepted", title: "Accepted" },
  { id: "rejected", title: "Rejected" }
]);

function validateForm(values) {
  let errors = Map();
  errors = validateIncludes(errors, values, "result", resultOptions.map(x => x.get("id")));
  errors = validatePresence(errors, values, "lab_name");
  errors = validatePresence(errors, values, "test_nr");
  return errors.toJS();
}

class RecordWaterTestResultForm extends Component {

  render() {
    let {handleSubmit, submit, submitInfo} = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Pallet id"
              name="pallet_id"
              active={false}
              component={TextInputField}
              />
            <Field 
              label="Result"
              name="result"
              component={DropDownInputField}
              data={resultOptions}
              valueKey="id"  
              titleKey="title" 
              />
            <Field 
              label="Lab name"
              name="lab_name"
              component={TextInputField}
              />
            <Field 
              label="Test nr"
              name="test_nr"
              component={TextInputField}
              />
          </FormFieldsTable>
        </div>
        <div className="buttons">
          <ActionButton label={submitLabel(submitInfo, "Submit")} onClick={submit} active={!isSubmitting(submitInfo)} />
          <ActionButton label="Cancel" active={!isSubmitting(submitInfo)} onClick={this.props.cancelRecordWaterTestResult} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "RecordWaterTestResultForm",
  validate: validateForm
})(RecordWaterTestResultForm);

const ConnectedForm = connect(
  (state, ownProps) => ({
    submitInfo: getSubmitInfoForCommand(state.get("inventory"), "RecordWaterTestResult"),
    initialValues: {
      pallet_id: ownProps.pallet_id
    }
  }),
  {
    cancelRecordWaterTestResult,
    submit,
    onSubmit: (data) => recordWaterTestResult(data)
  }
)(ReduxForm);

export default ConnectedForm;